<ng-content *ngIf="enabled"></ng-content>

<ng-container *ngIf="!enabled">
  <div (click)="facade.showFeatureInfo(mode, feature)">
    <ng-container *ngIf="customTpl; then customTpl; else defaultButton"> </ng-container>
  </div>
</ng-container>

<ng-template #defaultButton>
  <rt-button variant="secondary">
    <rt-icon name="add"></rt-icon>
    <div layout-horizontal layout-align-items-center>
      {{ defaultBtnText }}
      <rt-icon
        name="upgrade"
        size="small-x"
        colorToken="colorIconScaleDefault"
        margin-left-small-x
      ></rt-icon>
    </div>
  </rt-button>
</ng-template>
